<div style="margin: 10px;">

	<prtg-export-config [Network]="Network" [PrtgExport]="PrtgExport"
						[EnableExportOrigin]="true"></prtg-export-config>

</div>
